import React from 'react'

// icons
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// routes
import { withRouter } from 'react-router-dom'

// hooks
import useDeleteArticuloPrecio from './hooks/useDeleteArticuloPrecio'

const ItemArticuloPrecio = ({ articuloPrecio, history, setIsLoad }) => {
    const eliminarArticuloPrecio = useDeleteArticuloPrecio(setIsLoad)

    return (
        <tr key={parseInt(articuloPrecio.articulo.id)}>
            <th scope="row">{articuloPrecio.articulo.codigo}</th>
            <td>{articuloPrecio.articulo.nombre}</td>
            <td>{articuloPrecio.precio}</td>
            <td>
                <button
                    className="btn text-danger"
                    onClick={() => {
                        history.push(
                            `/edit-articulo-precio/${articuloPrecio.articulo.id}/${articuloPrecio.listaPrecio.id}`,
                            {
                                codigoArticulo: articuloPrecio.articulo.codigo,
                                precio: articuloPrecio.precio
                            }
                        )
                    }}
                >
                    <FontAwesomeIcon icon={faEdit} /> Editar
                </button>
                <button
                    className="btn text-primary"
                    onClick={() => {
                        eliminarArticuloPrecio(articuloPrecio.articulo.id, articuloPrecio.listaPrecio.id)
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} /> Eliminar
                </button>
            </td>
        </tr>
    )
}

export default withRouter(ItemArticuloPrecio)
